import * as React from "react";
import { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { Button, Card, CardBody } from "reactstrap";
import { toast } from "react-toastify";

import Loader from "../../../common/Loader";
import MenuBar from "../../../components/MenuBar";

import * as Content from "../../../services/api/Content";

/**
 * "Review queue" as a destination in its own right, which is how the nav and
 * the designs treat it — the review screen itself is per-batch and carries a
 * switcher, so entering from the menu means landing on the newest draft and
 * switching from there.
 *
 * Newest by creation, matching the order `listBatches` already returns, so this
 * is the batch someone who just generated is looking for.
 */
export const ContentReviewEntryPage: React.FC = () => {
  const [target, setTarget] = useState<string | null>(null);
  const [empty, setEmpty] = useState(false);

  useEffect(() => {
    let cancelled = false;

    Content.listBatches({ state: "draft" })
      .then(({ items }) => {
        if (cancelled) {
          return;
        }
        const newest = (items ?? [])[0];
        if (newest) {
          setTarget(newest.id);
        } else {
          setEmpty(true);
        }
      })
      .catch((error) => {
        if (!cancelled) {
          toast.error(
            (error as Error).message || "Could not find a batch to review",
          );
          setEmpty(true);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (target) {
    return <Redirect to={`/content/drafts/${target}`} />;
  }

  if (!empty) {
    return (
      <>
        <MenuBar />
        <Loader />
      </>
    );
  }

  return (
    <>
      <MenuBar />
      <Card>
        <CardBody className="text-center py-5">
          <p className="text-muted mb-3">
            No draft batches to review. Generate one to get started.
          </p>
          <Button color="primary" href="/content/generate">
            <i className="fas fa-magic mr-2" />
            Generate
          </Button>
        </CardBody>
      </Card>
    </>
  );
};
